module.exports = __webpack_public_path__ + "media/slider/WelcomeToComposzMobileIndia-0e1ba5b1.jpg";